import './bulma.css';

import { InitializeApplication } from '@dealstack/frontend/admin/components/global/InitializeApplication/InitializeApplication';
import { createRoot } from 'react-dom/client';
import '@dealstack/frontend/shared/index.css';
import { startHostedAuthIfOnLoginRoute } from '@dealstack/frontend/shared/pages/AuthStart/startHostedAuth';
import { ApplicationType } from '@dealstack/shared/lib/generated';

if (!startHostedAuthIfOnLoginRoute(ApplicationType.GODMODE)) {
	const container = document.getElementById('root');
	// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	const root = createRoot(container!);

	root.render(<InitializeApplication />);
}
